<template>
  <div class="AgreementsBank">
    <a class="send-button" @click="showModal">コード検索</a>
    <component-modal v-show="condition.condition" transition="expand">

      <template slot="title">
        銀行コード・支店コード検索
      </template>

      <div slot="body" class="wrapper">
        <div class="bank-list">

          <input type="text" v-model="bank_name" @keyup="getBanks" placeholder="銀行名" style="width: 100%" @keypress.self.prevent.13>
          <table-c>
            <tr-c slot="tr-th">
              <th-c>銀行コード</th-c>
              <th-c>銀行名</th-c>
            </tr-c>
            <tr-c slot="tr-td" v-for="list in banks" :key="list.id" @click.native="getBranches(list)" class="tr_hover">
              <td-c>{{list.code}}</td-c>
              <td-c>{{list.name}}</td-c>
            </tr-c>
          </table-c>

          <input type="text" v-model="branch_name" @keyup="getBranchesSearch" placeholder="支店名" style="width: 100%" @keypress.self.prevent.13>
          <table-c>
            <tr-c slot="tr-th">
              <th-c>支店コード</th-c>
              <th-c>支店名</th-c>
            </tr-c>
            <tr-c slot="tr-td" v-for="list in branches" :key="list.id" @click.native="pushBranchesCode(list)" class="tr_hover">
              <td-c>{{list.code}}</td-c>
              <td-c>{{list.name}}</td-c>
            </tr-c>
          </table-c>

        </div>
        <div style="display: flex">
          <input type="text" disabled v-model="bank_code" placeholder="銀行番号" style="width: 100%">
          <input type="text" disabled v-model="branches_code" placeholder="支店番号" style="width: 100%">
        </div>
      </div>

      <div class="footer" slot="footer">
        <btn @click.native.self.prevent.13="showModal('ok')">決定</btn>
        <btn @click.native.self.prevent.13="showModal('ng')">キャンセル</btn>
      </div>

    </component-modal>
  </div>
</template>

<script>
let _ = window._
export default {
  props: {
    agreement: Object
  },
  name: 'AgreementsBank',
  data () {
    return {
      condition: {
        condition: false
      },

      bank_name: '',
      bank_code: '',
      branch_name: '',
      branches_code: ''
    }
  },

  computed: {
    banks () {
      return this.$store.getters.banks
    },

    branches () {
      return this.$store.getters.branches
    }
  },
  watch: {
  },
  methods: {
    showModal (val) {
      if (val === 'ok') {
        this.agreement.bank_number = this.bank_code
        this.agreement.branch_number = this.branches_code
        this.condition.condition = !this.condition.condition
      } else {
        this.condition.condition = !this.condition.condition
      }
    },

    getBanks: _.debounce(function () {
      this.$store.dispatch('getBanks', {
        bank_name: this.bank_name
      })
      this.$store.state.list.branches = ''
      this.bank_code = ''
      this.branches_code = ''
    }),

    getBranches (list) {
      this.bank_code = list.code
      this.$store.dispatch('getBranches', {
        bank_code: list.code
      })
    },

    getBranchesSearch: _.debounce(function () {
      this.$store.dispatch('getBranchesSearch', {
        branch_name: this.branch_name,
        bank_code: this.bank_code
      })
      this.branches_code = ''
    }),

    pushBranchesCode (list) {
      this.branches_code = list.code
    }
  }
}
</script>

<style lang='scss' scoped>
.send-button {
  cursor: pointer;
  color: #fff;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.wrapper {
  display: flex;
  flex-flow: column;
  /* border-top: solid 1px #ccc; */
  max-height: 340px;
}
.bank-list {
  overflow: scroll;
  margin: 5px 0;
}
.table {
  margin: 0;
  width: 100%;
  .tr {
    color: #000;
    &:hover {
      color: #fff;
    }
    .th {
      background: #37474f;
      color: #fbfbfb;
      width: 50%;
    }
  }
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// AgreementsBank.vue?0cbc4ac6